import React, { lazy, LazyExoticComponent, ComponentType } from "react";

interface LazyWithReloadOptions {
  isChunkError?: (e: Error) => boolean;
}

export function lazyWithReload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  { isChunkError }: LazyWithReloadOptions = {},
): LazyExoticComponent<T> {
  let attempts = 0;

  const defaultDetector = (err: Error) =>
    /failed to fetch dynamically imported module/i.test(err.message) ||
    /vite: preload/i.test(err.message);

  const detect = isChunkError ?? defaultDetector;

  const wrapped = () => {
    return factory().catch((err) => {
      if (detect(err) && attempts < 1) {
        attempts += 1;

        setTimeout(() => window.location.reload(), 50);

        return new Promise<never>(() => {});
      }

      throw err;
    });
  };

  return lazy(wrapped);
}
